































































































import { log } from '@/log'
import {
  ContactLensImageType,
  loadContactLensImageType,
  saveContactLensImageType,
} from '@/services/contact-lens-image-type/contact-lens-image-type-storage'
import { FkuItemPrice, HlItemListApi } from '@hl-itemlist/api/itemlist-api'
import ColumnCountSwitcher from '@hl-itemlist/components/ColumnCountSwitcher.vue'
import FilterModal from '@hl-itemlist/components/FilterModal.vue'
import ImageTypeSwitcher from '@hl-itemlist/components/ImageTypeSwitcher.vue'
import OtherProductsModal from '@hl-itemlist/components/OtherProductsModal.vue'
import ProductGrid from '@hl-itemlist/components/ProductGrid.vue'
import SortSwitcher from '@hl-itemlist/components/SortSwitcher.vue'
import { colorFamilyLabel } from '@hl-itemlist/model/color-family'
import {
  ActiveFilterChip,
  activeFilterChips,
  cloneCondition,
  createDefaultCondition,
  descriptionForCondition,
  hasKeyword as conditionHasKeyword,
  ItemListCondition,
  parseItemListCondition,
  removeSelectedFilter,
  resetFilters,
  SelectOption,
  setKeyword,
  setSort,
  SortType,
  StringArrayFilterKey,
  titleForCondition,
} from '@hl-itemlist/model/condition'
import { DraftStats } from '@hl-itemlist/model/draft-stats'
import { LensSizeCandidatesState } from '@hl-itemlist/model/lens-size-candidates-state'
import { ListError } from '@hl-itemlist/model/list-error'
import { applyConditionToSearch, canonicalSearch, parsePageParts } from '@hl-itemlist/model/page-url'
import { appendPage, createInitialProductList } from '@hl-itemlist/model/product-list'
import { ProductPriceView, toProductPriceView, UNAVAILABLE_PRICE_VIEW } from '@hl-itemlist/model/product-price'
import { loadSpColumnCount, saveSpColumnCount, SpColumnCount } from '@hl-itemlist/model/sp-column-count'
import Vue from 'vue'

const FIRST_PAGE = 1

// ツールバーの貼り付け先となるサイトヘッダー(.l-header-containerがsticky top:0で貼り付く)
const SITE_HEADER_SELECTOR = '.l-header-container'

// ヘッダーとツールバーの間の余白
const TOOLBAR_PINNED_GAP = 8

// 絞り込みFABを引っ込める/戻すまでのスクロール量。戻す側を短くして、絞り込みたくなったらすぐ出るようにする
const FILTER_FAB_HIDE_SCROLL_DISTANCE = 80
const FILTER_FAB_SHOW_SCROLL_DISTANCE = 40

// FABを引っ込めてよい最低条件とする、一覧を読み進めた量(画面高さに対する割合)
const FILTER_FAB_HIDE_MIN_LIST_READ_RATIO = 0.5

// PC表示とみなす幅の下限(グリッドが常に4列になるブレークポイントと合わせる。ProductGridのmedia query参照)
const PC_MIN_WIDTH = 768

export default Vue.extend({
  components: {
    ColumnCountSwitcher,
    FilterModal,
    ImageTypeSwitcher,
    OtherProductsModal,
    ProductGrid,
    SortSwitcher,
  },
  data() {
    return {
      api: new HlItemListApi(),
      // モーダル内で条件を一度でも編集したか(編集の結果、元と同じ条件に戻っていてもtrue)。
      // 適用時に一覧トップへスクロールを戻すかの判定に使う(applyDraftConditionのコメント参照)
      draftEdited: false,
      // モーダル内で編集中の条件(下書き)。適用するまでconditionには反映しない
      draftCondition: createDefaultCondition(),
      // 下書き条件に該当する件数プレビューの取得状態(表示との対応はDraftStatsのコメント参照)
      draftStats: { state: 'loading' } as DraftStats,
      filterModalOpen: false,
      // モーダルを開いたときにキーワード入力欄へフォーカスするか(0件からの「検索キーワードを変更する」導線用)
      filterModalFocusKeyword: false,
      otherProductsModalOpen: false,
      // 絞り込みFABを下方向スクロールで引っ込めているか(updateFilterFabScrollVisibility参照)
      filterFabScrollHidden: false,
      // FABの表示切替の判定起点。表示中は「最も上まで戻った位置」、非表示中は「最も下まで進んだ位置」を持つ。
      // 初期値は現在位置(履歴復元などで途中までスクロールされた状態で読み込まれることがある)
      filterFabScrollAnchor: window.pageYOffset,
      // 既存商品一覧と同じlocalStorageキーを共有し、最後に選んだ画像種別を引き継ぐ
      imageType: loadContactLensImageType(),
      // レンズサイズの絞り込み候補。一覧と並行してcreatedで先読みする(loadLensSizeCandidatesのコメント参照)
      lensSizeCandidates: { state: 'loading' } as LensSizeCandidatesState,
      listError: 'none' as ListError,
      // 一覧(このコンポーネントの要素)の一部が画面内にあるか。絞り込みFABと貼り付き中ツールバーの表示条件
      // (観測の開始と非対応環境の扱いはobserveListInViewのコメント参照)
      listInView: false,
      listInViewObserver: null as IntersectionObserver | null,
      // 表示中の一覧の「世代」。絞り込み条件の確定=再取得のたびに進み、後着した古い世代のレスポンス
      // (1ページ目・追加ページとも)を捨てる判定に使う。ページ取得ごとには進まない(loadMoreは現世代に参加する)
      listGeneration: 0,
      loading: false,
      // 商品一覧の読み込み状態。1ページ反映ごとに操作(model/product-list.ts)が返す新しい状態へ丸ごと差し替える
      productList: createInitialProductList(),
      condition: parseItemListCondition(window.location.search),
      statsRequestId: 0,
      // スマホ表示時の列数(2/3/4)。画像種別と同様に直近の選択をlocalStorageから引き継ぐ。
      // PCは常に4列で切替対象外(切替UIもPCでは非表示)
      spColumnCount: loadSpColumnCount(),
      // ツールバーの貼り付け(fixed化)状態と、そのときの位置・寸法。
      // 祖先(.l-container)が overflow: hidden を持ち position: sticky が効かないため、
      // 親のCSSに介入せず、スクロールに応じてfixedへ切り替える方式にしている。
      // ヘッダーの高さはブランドCSS(CMS注入含む)で変わりうるため、固定値でなく実測する。
      pinned: false,
      pinnedTop: 0,
      // ページパーツ(parts)指定。絞り込み条件ではなく、正規URL・canonicalの導出に渡すためだけに保持する
      // (表示内容はSSRでserver所有。model/page-url.tsのparsePagePartsのコメント参照)
      pageParts: parsePageParts(window.location.search),
      // 商品(FKU)id → 価格表示。一覧のレスポンスに価格は含まれないため、ページ取得ごとに別途バッチ取得して埋める
      prices: {} as { [fkuItemId: number]: ProductPriceView },
      // 既定のmeta description。サーバーが出力した初期値から引き継ぎ、条件文の後ろにつなげる
      defaultDescription: '',
      // タイトルのサイト名部分(「 | ホテラバ〜」)。サーバーが出力した初期タイトルから引き継ぐ
      siteTitleSuffix: '',
      toolbarHeight: 0,
      toolbarLeft: 0,
      toolbarWidth: 0,
    }
  },
  computed: {
    activeChips(): ActiveFilterChip[] {
      return activeFilterChips(this.condition, this.arrayOptionLabel)
    },
    anchorStyle(): { [key: string]: string } {
      return this.pinned ? { height: `${this.toolbarHeight}px` } : {}
    },
    // 表示中の条件にキーワードがあるか(ProductGridの0件導線の出し分け用)。未指定の判定はconditionモデルに委ねる
    hasKeyword(): boolean {
      return conditionHasKeyword(this.condition)
    },
    /**
     * 絞り込みFABを出すか。切り替えの条件は2つあり、どちらで切り替わっても見え方は同じ(templateのコメント参照)。
     * - 一覧が画面内にあるか(observeListInView)
     * - 一覧を読み進めている途中でないか(updateFilterFabScrollVisibility。SP幅のみ)
     */
    filterFabVisible(): boolean {
      return this.listInView && !this.filterFabScrollHidden
    },
    toolbarStyle(): { [key: string]: string } {
      if (!this.pinned) {
        return {}
      }
      // 一覧が画面外(下のフッターフリーエリア等を読んでいる間)は、貼り付いたツールバーを出し続けない。
      // pinned自体は維持して表示だけを消す(アンカーの確保高さを保ち、解除によるレイアウトジャンプを避ける)
      if (!this.listInView) {
        return { display: 'none' }
      }

      return {
        position: 'fixed',
        top: `${this.pinnedTop}px`,
        left: `${this.toolbarLeft}px`,
        width: `${this.toolbarWidth}px`,
      }
    },
  },
  created() {
    window.addEventListener('popstate', this.onPopState)
    // head要素の差し替えを始める前に、サーバーが出力したサイトタイトル部と既定descriptionを控えておく
    this.captureServerRenderedHead()
    this.refreshHead()
    // 候補は一覧と並行して先読みする(モーダルを開いたときに揃っている状態を狙う)
    this.loadLensSizeCandidates()
    this.reloadProducts()
  },
  mounted() {
    this.updateToolbarPinning()
    window.addEventListener('scroll', this.updateToolbarPinning, { passive: true })
    window.addEventListener('scroll', this.updateFilterFabScrollVisibility, { passive: true })
    window.addEventListener('resize', this.updateToolbarPinning)
    window.addEventListener('resize', this.updateFilterFabScrollVisibility)
    this.observeListInView()
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.onPopState)
    window.removeEventListener('scroll', this.updateToolbarPinning)
    window.removeEventListener('scroll', this.updateFilterFabScrollVisibility)
    window.removeEventListener('resize', this.updateToolbarPinning)
    window.removeEventListener('resize', this.updateFilterFabScrollVisibility)
    if (this.listInViewObserver) {
      this.listInViewObserver.disconnect()
    }
  },
  methods: {
    async reloadProducts(): Promise<void> {
      // 世代を進めて古い世代の実行中リクエストを無効化し、一覧と価格をまとめて作り直す
      this.listGeneration += 1
      this.productList = createInitialProductList()
      this.prices = {}

      await this.fetchListPage(this.listGeneration, FIRST_PAGE, 'initial')
    },
    async loadMore(): Promise<void> {
      if (this.loading || this.productList.reachedLast) {
        return
      }

      await this.fetchListPage(this.listGeneration, this.productList.currentPage + 1, 'more')
    },
    /**
     * 1ページ分の一覧取得の共通手続き。世代判定・取得中フラグ・エラー種別の記録を必ず同じ形で行う
     * (判定漏れが「古い一覧への追記」や「loadingの解除漏れ」に直結するため、取得は必ずここを通す)。
     * generationには呼び出し時点の世代を渡し、レスポンス到着時に世代が進んでいたら結果を捨てる。
     */
    async fetchListPage(generation: number, page: number, errorKind: Exclude<ListError, 'none'>): Promise<void> {
      this.loading = true
      this.listError = 'none'

      try {
        const response = await this.api.fetchList(this.condition, page)
        if (generation !== this.listGeneration) {
          return
        }
        this.productList = appendPage(this.productList, response)
        // 価格の取得で一覧の表示をブロックしない(後から埋まる)
        this.loadPrices(response.items.map(item => item.id))
      } catch (e) {
        // 原因(通信失敗/契約違反 items[n] does not satisfy the contract 等)の診断用に記録する
        log.error(`hl-itemlist: failed to load page ${page}`, e)
        if (generation === this.listGeneration) {
          this.listError = errorKind
        }
      } finally {
        if (generation === this.listGeneration) {
          this.loading = false
        }
      }
    },
    /**
     * 取得に失敗しても一覧自体は生かす(価格と一覧は独立)。
     *
     * pricesは「FKU id → 価格表示」のストアで、マップに無いid=取得未完了(空欄表示)。
     * 価格はFKU idにのみ依存しクエリに依らないため、並行する複数リクエストの結果を届いた順に反映してよい:
     * - レスポンスに該当FKUの結果がある場合は、常にその内容で代入する(実価格どうしの上書きや、
     *   0円=「価格なし」への書き換えを含む。サーバーが明示した最新の結果として採用する)
     * - 結果が無い場合(APIエラー・レスポンスに該当FKUが無い)は「情報なし」なので、
     *   取得未完了のFKUにだけ「価格なし(￥-)」を入れ、取得済みの値は上書きしない
     *   (遅れて解決した古いリクエストの失敗が、表示済みの価格を潰さないようにするため)
     * どちらの場合もマップからidを消すことはないため、取得済みから取得未完了(空欄)へ戻る遷移は起きない
     * (マップが空になるのは、一覧の再取得でストアごと作り直すときだけ)。
     * 「価格なし」表示の仕様はUNAVAILABLE_PRICE_VIEWのコメント参照。
     */
    async loadPrices(fkuItemIds: number[]): Promise<void> {
      let fetched: FkuItemPrice[]
      try {
        fetched = await this.api.fetchPrices(fkuItemIds)
      } catch (e) {
        log.error('hl-itemlist: failed to load prices', e)
        fetched = []
      }

      // 新規キーの追加はVue 2のリアクティビティが検知できないため、$setで代入する
      fkuItemIds.forEach((id) => {
        const price = fetched.find(item => item.fkuItemId === id)

        if (price) {
          this.$set(this.prices, id, toProductPriceView(price))
        } else if (!this.prices[id]) {
          // まだ値が取得できていない場合のみ「価格なし」を入れてよい(取得済みの値の上書きは禁止。
          // 表示済みの実価格を古いリクエストの失敗で潰さない)
          this.$set(this.prices, id, UNAVAILABLE_PRICE_VIEW)
        }
      })
    },
    updateSpColumnCount(count: SpColumnCount): void {
      this.spColumnCount = count
      saveSpColumnCount(count)
    },
    openFilterModal(): void {
      this.draftEdited = false
      this.draftCondition = cloneCondition(this.condition)
      // 開いた直後の下書きは表示中の一覧と同じ条件なので、件数プレビューも表示中の件数から始める
      // (一覧側の件数が未取得ならloading。裏で最新値を取り直す)
      this.draftStats = this.productList.totalItems !== null
        ? { state: 'success', total: this.productList.totalItems }
        : { state: 'loading' }
      this.filterModalFocusKeyword = false
      this.showFilterModal()
    },
    /**
     * キーワードだけを消した下書き(キーワード以外の条件は維持)で開き、
     * 入力欄へフォーカスして別のキーワードをすぐ入力できる状態にする。
     * リセットも編集として扱う(draftEdited)ので、入力せずそのまま適用するとキーワード無しの条件になる。
     */
    openFilterModalForNewKeyword(): void {
      this.draftEdited = true
      this.draftCondition = setKeyword(this.condition, '')
      // 下書きがキーワードリセット前と異なる条件で始まるため、件数プレビューは取り直す
      this.draftStats = { state: 'loading' }
      this.filterModalFocusKeyword = true
      this.showFilterModal()
    },
    // モーダルを開く共通の手続き。下書き・件数プレビューの初期化は呼び出し元(openFilterModal系)の責務
    showFilterModal(): void {
      this.filterModalOpen = true
      // 先読みが失敗していたら、開き直しのタイミングで再取得する
      if (this.lensSizeCandidates.state === 'error') {
        this.loadLensSizeCandidates()
      }
      this.fetchDraftStats()
    },
    // 変更を確定せずに閉じる(FilterModalの@close)。確定して閉じる方はapplyDraftCondition
    cancelFilterModal(): void {
      this.filterModalOpen = false
    },
    updateDraftCondition(next: ItemListCondition): void {
      this.draftEdited = true
      this.draftCondition = next
      // 編集した瞬間から古い件数を編集後の条件の件数として見せない
      // (特に0件でdisabledにした後の編集は、取得完了を待たずこの時点でボタンを押せる状態に戻す)。
      // キーワード連続入力の平準化はFilterModal側(入力確定のdebounce)の責務で、ここは編集ごとに即時取得する
      this.draftStats = { state: 'loading' }
      this.fetchDraftStats()
    },
    clearDraftCondition(): void {
      this.draftEdited = true
      this.draftCondition = resetFilters(this.draftCondition)
      this.draftStats = { state: 'loading' }
      this.fetchDraftStats()
    },
    /**
     * 下書き条件を適用する(適用後の手続きは条件変更に共通のapplyConditionが担う)。
     * 編集の有無は前後の条件の比較でなく「編集したか」で判定する(編集の結果元と同じ条件でも、
     * ユーザーは適用を意図している)。
     *
     * 編集せず「n件を表示」を閉じるボタンとして押したときは、条件が表示中の一覧と同一なので
     * モーダルを閉じるだけにする。再取得するとproductsが一旦空になりページ高の縮小で
     * スクロール位置が失われるため、同一URLの履歴エントリを積まないためでもある。
     */
    applyDraftCondition(): void {
      if (!this.draftEdited) {
        this.filterModalOpen = false

        return
      }

      this.filterModalOpen = false
      this.applyCondition(cloneCondition(this.draftCondition))
    },
    /**
     * 条件の変更を確定して一覧を作り直す共通の手続き。並び替え・絞り込みの適用・チップの個別解除・
     * 一括解除はどれも「表示する一覧の条件が変わった」という同じ操作なので、履歴への追加・headの同期・
     * 再取得と、変更後の結果を頭から見せるための一覧トップへのスクロール戻しを同じ形で行う。
     *
     * 戻る/進む(onPopState)はここを通さない: 履歴を積み直さず、スクロール位置もブラウザの復元に任せる。
     */
    applyCondition(next: ItemListCondition): void {
      this.condition = next
      this.pushCurrentState()
      this.refreshHead()
      this.reloadProducts()
      // 絞り込みモーダルからの適用では背景ロック(html/bodyのoverflow: hidden)の解除がモーダルの破棄時のため、
      // DOM更新を待ってからスクロールする
      this.$nextTick(() => this.scrollToListTop())
    },
    /**
     * 一覧(hl-itemlist)のトップが貼り付きヘッダーの下に来る位置までスクロールを戻す。
     * 既にそれより上を表示している場合は何もしない(下方向へはスクロールしない)。
     */
    scrollToListTop(): void {
      const header = document.querySelector(SITE_HEADER_SELECTOR)
      const headerHeight = header ? Math.round(header.getBoundingClientRect().height) : 0
      const top = window.pageYOffset + this.$el.getBoundingClientRect().top - headerHeight

      if (window.pageYOffset > top) {
        window.scrollTo(0, Math.max(0, top))
      }
    },
    removeChip(chip: ActiveFilterChip): void {
      this.applyCondition(removeSelectedFilter(this.condition, chip.filter))
    },
    clearFilters(): void {
      this.applyCondition(resetFilters(this.condition))
    },
    /**
     * レンズサイズの絞り込み候補を取得する。
     * 取得に失敗しても候補以外の絞り込みと一覧は使えるため、エラーはモーダル内の該当セクションの表示に留め、
     * モーダルを開いたタイミングで再取得する(openFilterModal)。
     * 取得完了までのチップのラベル解決は生の値のまま表示する(arrayOptionLabel)。
     */
    async loadLensSizeCandidates(): Promise<void> {
      this.lensSizeCandidates = { state: 'loading' }
      try {
        this.lensSizeCandidates = { state: 'success', candidates: await this.api.fetchLensSizeCandidates() }
        // 生の値で仮表示していたラベル(タイトル内の条件表記)を正式なラベルへ置き換える
        this.refreshHead()
      } catch (e) {
        log.warn('hl-itemlist: failed to load lens size candidates', e)
        this.lensSizeCandidates = { state: 'error' }
      }
    },
    /**
     * 件数プレビューの更新。loadingへの遷移はここでなく条件が編集された時点で行う
     * (updateDraftCondition / clearDraftCondition / openFilterModalForNewKeyword。
     * 通常導線で開いた直後の裏取り直しでは表示中の件数を出したままにするため)。
     * 複数リクエストが並行したときは最新のリクエストの結果だけを採用する。
     * 取得開始時のrequestId更新が、実行中の古いリクエストの無効化を兼ねる
     * (編集→取得開始は同一tickで走るため、間に古いレスポンスの採用が割り込む余地はない)。
     */
    async fetchDraftStats(): Promise<void> {
      const requestId = this.statsRequestId + 1
      this.statsRequestId = requestId

      try {
        const total = await this.api.fetchStats(this.draftCondition)
        if (requestId === this.statsRequestId) {
          this.draftStats = { state: 'success', total }
        }
      } catch (_) {
        // 取得に失敗しても適用は妨げない(ボタンは件数なしの「この条件で表示」になる)
        if (requestId === this.statsRequestId) {
          this.draftStats = { state: 'error' }
        }
      }
    },
    /**
     * 配列filterの値→表示ラベル(値部分のみ。「DIA」等のキーの見出しはconditionモデルが合成する)。
     * 候補APIが未取得の間は生の値のまま表示する。
     * 語彙をconditionモデルが持つexpirationPeriodはactiveFilterChips側で解決されるため、ここには来ない。
     */
    arrayOptionLabel(key: StringArrayFilterKey, value: string): string {
      if (key === 'colorFamilies') {
        return colorFamilyLabel(value)
      }

      const candidatesState = this.lensSizeCandidates
      const candidates = candidatesState.state === 'success'
        ? candidatesState.candidates
        : { diameters: [], graphicDiameters: [], baseCurves: [] }
      if (key === 'diameter') {
        return this.lensSizeLabel(candidates.diameters, value)
      }
      if (key === 'graphicDiameter') {
        return this.lensSizeLabel(candidates.graphicDiameters, value)
      }

      return this.lensSizeLabel(candidates.baseCurves, value)
    },
    lensSizeLabel(options: ReadonlyArray<SelectOption>, value: string): string {
      const matched = options.find(option => option.value === value)

      return matched ? matched.label : value
    },
    chipKey(chip: ActiveFilterChip): string {
      return chip.filter.kind === 'q' ? 'q' : `${chip.filter.kind}:${chip.filter.key}:${chip.label}`
    },
    updateImageType(type: ContactLensImageType): void {
      this.imageType = type
      saveContactLensImageType(type)
    },
    /**
     * anchor(常にフロー内に留まる)の位置がヘッダー下端+余白を越えて上へスクロールされたら、
     * ツールバーをfixedでヘッダー下に貼り付ける。位置・幅はanchorの実測値に追従させる。
     */
    updateToolbarPinning(): void {
      const anchor = this.$refs.toolbarAnchor as HTMLElement | undefined
      if (!anchor) {
        return
      }

      const header = document.querySelector(SITE_HEADER_SELECTOR)
      const headerHeight = header ? Math.round(header.getBoundingClientRect().height) : 0
      const anchorRect = anchor.getBoundingClientRect()

      this.pinnedTop = headerHeight + TOOLBAR_PINNED_GAP
      this.toolbarLeft = Math.round(anchorRect.left)
      this.toolbarWidth = Math.round(anchorRect.width)
      if (!this.pinned) {
        this.toolbarHeight = Math.round(anchorRect.height)
      }
      this.pinned = anchorRect.top <= this.pinnedTop
    },
    /**
     * 一覧を読み進めている間は絞り込みFABを引っ込め、読み戻し始めたら出す
     * (ビューポート固定で商品を覆い続けるため)。引っ込めるのは商品を半画面分ほど見た後から
     * (scrolledPastHalfScreenOfList)。
     *
     * 移動量の判定は「直近の切り替え以降、逆方向へ最も進んだ位置(anchor)からの距離」で行う。
     * anchorは状態を維持する向きへ動くたびに更新するので、
     * - 下へ長く進んだ後は「そこから少し戻す」だけで出る(戻し始めた位置が起点になる)
     * - 数pxの揺れや慣性の折り返しでは切り替わらない(しきい値に届かない)
     * ようになる。スクロール1回分の差分で方向を見る実装では前者が満たせない(ずっと下まで戻さないと出ない)。
     */
    updateFilterFabScrollVisibility(): void {
      // PCは商品を覆わない位置に余裕があるため、スクロールでは出し入れしない(一覧との交差だけで決める)。
      // SP幅で引っ込めた後にPC幅へ変わったとき(回転・ウィンドウ変形)はここで出した状態へ戻すため、
      // このメソッドはresizeでも呼ぶ
      if (window.innerWidth >= PC_MIN_WIDTH) {
        this.filterFabScrollHidden = false

        return
      }

      const current = window.pageYOffset

      if (this.filterFabScrollHidden) {
        if (current > this.filterFabScrollAnchor) {
          // さらに下へ進んだ(隠したままでよい)。戻し量の起点を最も下の位置へ移す
          this.filterFabScrollAnchor = current
        } else if (this.filterFabScrollAnchor - current >= FILTER_FAB_SHOW_SCROLL_DISTANCE) {
          this.filterFabScrollHidden = false
          this.filterFabScrollAnchor = current
        }

        return
      }

      if (current < this.filterFabScrollAnchor) {
        // さらに上へ戻った(出したままでよい)。進み量の起点を最も上の位置へ移す
        this.filterFabScrollAnchor = current

        return
      }
      if (
        current - this.filterFabScrollAnchor >= FILTER_FAB_HIDE_SCROLL_DISTANCE
        && this.scrolledPastHalfScreenOfList()
      ) {
        this.filterFabScrollHidden = true
        this.filterFabScrollAnchor = current
      }
    },
    /**
     * 商品を半画面分ほど見たか(FABを引っ込めてよい最低条件)。
     *
     * ページ先頭からのスクロール量では判定できない。上部に?parts=のページパーツがSSRされる構成では
     * 一覧に到達した時点で既に長くスクロールされているため、一覧を見始めた瞬間にFABが消えてしまう。
     * 一覧の上端が画面の半分より上へ抜けたかで見る。
     */
    scrolledPastHalfScreenOfList(): boolean {
      return this.$el.getBoundingClientRect().top <= -window.innerHeight * FILTER_FAB_HIDE_MIN_LIST_READ_RATIO
    },
    /**
     * 絞り込みFABと貼り付き中ツールバーの表示条件「一覧の一部が画面内にあるか」の観測を始める。
     * どちらもビューポート固定でページ全体に浮くため、一覧が見えていないビュー
     * (上のページパーツ(?parts=)や下のフッターフリーエリア等を読んでいる間)にも残ってしまう。
     * 交差判定できない環境では、絞り込みの入口を失わないよう常時表示に倒す。
     */
    observeListInView(): void {
      if (!('IntersectionObserver' in window)) {
        this.listInView = true

        return
      }

      this.listInViewObserver = new IntersectionObserver((entries) => {
        // 交差変化は複数まとめて届きうるため、最新(末尾)のentryで現在の状態を判定する(ProductGridのコメント参照)
        const latest = entries[entries.length - 1]
        if (latest) {
          this.listInView = latest.isIntersecting
        }
      })
      this.listInViewObserver.observe(this.$el)
    },
    updateSort(sort: SortType): void {
      // 同じ並び順の再選択では何もしない(不要な履歴追加・再取得をしない)
      if (sort === this.condition.sort) {
        return
      }

      this.applyCondition(setSort(this.condition, sort))
    },
    /**
     * 戻る/進むでは条件を復元して一覧を再取得し、head(タイトル・description・canonical)も同期し直す。
     * partsも現在のURLから取り直す(パーツの表示内容自体はSSRのため差し替わらないが、
     * 正規URL・canonicalの導出には現在のURLの値を使う)。
     */
    onPopState(): void {
      this.condition = parseItemListCondition(window.location.search)
      this.pageParts = parsePageParts(window.location.search)
      this.refreshHead()
      this.reloadProducts()
    },
    captureServerRenderedHead(): void {
      // サーバー(MetadataHelper)は「ページ名 | サイトタイトル」形式でtitleを出力する。
      // サイトタイトル部と既定descriptionをここでハードコードせず初期値から引き継ぐことで、供給源を他のMPAページと揃える
      const initialTitle = document.title
      const separatorIndex = initialTitle.indexOf(' | ')

      this.siteTitleSuffix = separatorIndex >= 0 ? initialTitle.slice(separatorIndex) : ''

      const meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null
      this.defaultDescription = meta ? meta.content : ''
    },
    /**
     * タイトルとcanonicalを現在の条件に同期する(初期表示・条件変更・履歴操作のたびに呼ぶ)。
     * 正規化で同じURLになる条件は同じtitle/canonicalに、異なる条件は異なるtitle/canonicalになる(SEO要件)。
     * canonicalはサーバーも初期表示で出力するが、正規形(既定値省略・安定順序)への正規化はここで行う。
     */
    refreshHead(): void {
      document.title = titleForCondition(this.condition, this.arrayOptionLabel) + this.siteTitleSuffix
      this.updateDescription()
      this.updateCanonical()
    },
    updateDescription(): void {
      const meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null
      if (!meta) {
        return
      }

      meta.content = descriptionForCondition(this.condition, this.arrayOptionLabel) + this.defaultDescription
    },
    updateCanonical(): void {
      const serialized = canonicalSearch(this.condition, this.pageParts)
      const href = serialized
        ? `${window.location.origin}${window.location.pathname}?${serialized}`
        : `${window.location.origin}${window.location.pathname}`
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null

      if (!link) {
        link = document.createElement('link')
        link.rel = 'canonical'
        document.head.appendChild(link)
      }
      link.href = href
    },
    /**
     * 条件の変更を履歴へ積む。遷移先URLは現在のクエリへ条件を適用して組み立て、
     * hl-itemlistが所有しないクエリ(parts・計測パラメータ等)は保持する(applyConditionToSearchのコメント参照)。
     */
    pushCurrentState(): void {
      const serialized = applyConditionToSearch(this.condition, window.location.search)
      const url = serialized ? `${window.location.pathname}?${serialized}` : window.location.pathname

      window.history.pushState({}, '', url)
    },
  },
})
